module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/UnitsList/images/sortie-6.8e48c671.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitsList/images/sortie-6.png
// module id = 2759
// module chunks = 11